import colors from "../colors";

export default colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/src/categorical/Accent.js
// module id = DSoQ
// module chunks = 0